import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburgerMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		d: "M15.25,12 C15.6642136,12 16,12.3357864 16,12.75 C16,13.1642136 15.6642136,13.5 15.25,13.5 L15.25,13.5 L0.75,13.5 C0.335786438,13.5 6.87099898e-12,13.1642136 6.87094825e-12,12.75 C6.87089753e-12,12.3357864 0.335786438,12 0.75,12 L0.75,12 Z M15.25,6 C15.6642136,6 16,6.33578644 16,6.75 C16,7.16421356 15.6642136,7.5 15.25,7.5 L15.25,7.5 L0.75,7.5 C0.335786438,7.5 -4.04958633e-13,7.16421356 -4.05009359e-13,6.75 C-4.05060086e-13,6.33578644 0.335786438,6 0.75,6 L0.75,6 Z M15.25,0 C15.6642136,-7.6089797e-17 16,0.335786438 16,0.75 C16,1.16421356 15.6642136,1.5 15.25,1.5 L15.25,1.5 L0.75,1.5 C0.335786438,1.5 -4.04958633e-13,1.16421356 -4.05009359e-13,0.75 C-4.05060086e-13,0.335786438 0.335786438,7.6089797e-17 0.75,0 L0.75,0 Z",
		id: "path-1"
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Icon-/-Header-/-Hamburger-menu",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Colors-/-Neutral-/-Black",
			transform: "translate(4.000000, 5.000000)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "mask-2",
					fill: "white",
					children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
				}),
				/* @__PURE__ */ _jsx("use", {
					id: "Mask",
					fill: "#231F20",
					xlinkHref: "#path-1"
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask-2)",
					fill: "currentColor",
					id: "Rectangle",
					children: /* @__PURE__ */ _jsx("g", {
						transform: "translate(-4.000000, -5.000000)",
						children: /* @__PURE__ */ _jsx("rect", {
							x: 0,
							y: 0,
							width: 24,
							height: 24
						})
					})
				})
			]
		})
	})]
});
export default SvgHamburgerMenu;
